module.exports = __webpack_public_path__ + "static/media/1.21670d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/1.jpg
// module id = 185
// module chunks = 0